import { render, staticRenderFns } from "./PlainHeader.vue?vue&type=template&id=7a8708a8&"
import script from "./PlainHeader.vue?vue&type=script&lang=ts&"
export * from "./PlainHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports